class Setting {
  env: string;
  apiServerUrl: string;
  cdnPrefix: string;

  constructor() {
    this.env = process.env.REACT_APP_ENV || EMPTY;
    this.apiServerUrl = process.env.REACT_APP_API_URL || EMPTY;
    this.cdnPrefix = process.env.REACT_APP_CDN_PREFIX || EMPTY;
  }
}

const EMPTY: string = '';

const config: Setting = new Setting();

export { Setting, config };
